import {Component} from '@angular/core';
import packageJson from '../../package.json';
import {Observable} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import {OdHeaderComponent, OdLoadingSpinnerComponent} from 'od-component-library';
import {LoadingService} from '_@shared/services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [AsyncPipe, RouterOutlet, OdLoadingSpinnerComponent, OdHeaderComponent],
})
export class AppComponent {
  title = 'Operation Level';
  version: string = packageJson.version;
  isLoading$: Observable<boolean>;
  isAuthenticated$: Observable<boolean>;
  
  constructor(
    public loadingService: LoadingService
  ) {
    this.isLoading$ = loadingService.isLoading$;
  }
}
